<template lang="pug">
  div
    div.p1.basic700--text Select courier service
    v-radio-group(v-if="showRadio" v-model="courierService" row dense)
      v-row(no-gutters)
        v-col
          v-radio(value="pickup" color="info500")
            template(v-slot:label)
              div.p2.primary--text Pick up
        v-col
          v-radio(value="dropoff" color="info500")
            template(v-slot:label)
              div.p2.primary--text Drop-off
    template
      template(v-if="errorRate")
        div.mt-3.s2.danger500--text {{ errorRate.error }}

      template(v-for="courier in couriers")
        div.px-2.py-4.my-2(:style="courier.disabled ? disabledBorder : (selectedFulfilment && courier.signature === selectedFulfilment.signature) ? activeBorder : inactiveBorder" @click="courier.disabled ? '' : selectedFulfilment = courier")
          v-row(no-gutters align="center")
            v-col.shrink
              div(style="width: 72px" align="center")
                v-img(v-if="courier.meta_data" :src="courier.meta_data.shipping_logo || require('@/assets/image_placeholder.png')" contain max-width="72" max-height="32")
            v-col.pl-2(v-if="courier.meta_data")
              div.p2.basic700--text {{ courier.meta_data.delivery_time }}
              div.p2.basic700--text {{ courier.meta_data.service_type }}
            v-col(cols="3")
              div.p2.basic700--text {{ courier.fee | displayPrice }}
          div.s2.danger500--text(v-if="courier.error") {{ courier.error }}
</template>

<script>
export default {
  name: 'SelectCourier',
  props: ['parentRates', 'parentSelectedFulfilment'],
  data: () => ({
    activeBorder: {
      border: '2px solid var(--v-info500)',
      borderRadius: '4px',
      backgroundColor: 'var(--v-infoT08)'
    },
    inactiveBorder: {
      border: '1px solid var(--v-basic400)',
      borderRadius: '4px',
    },
    disabledBorder: {
      borderRadius: '4px',
      backgroundColor: 'var(--v-basic300)',
      opacity: 0.5
    },
    pickupCouriers: null,
    dropoffCouriers: null,
    courierService: null,
    showRadio: true,
  }),
  computed: {
    rates: {
      get () {
        return this.parentRates
      },
      set (newValue) {
        this.$emit('update:parentRates', newValue)
      }
    },
    errorRate() {
      return this.rates.find(rate => rate.disabled && rate.error.includes('courier')) || null
    },
    selectedFulfilment: {
      get () {
        return this.parentSelectedFulfilment
      },
      set (newValue) {
        this.$emit('update:parentSelectedFulfilment', newValue)
      }
    },
    couriers () {
      if (this.courierService === 'pickup') {
        return this.pickupCouriers
      } else if (this.courierService === 'dropoff') {
        return this.dropoffCouriers
      } else {
        return []
      }
    }
  },
  watch: {
    rates: {
      deep: true,
      immediate: true,
      handler (val) {
        if (val.length > 0) {
          this.pickupCouriers = [...val.filter(f => f.meta_data && f.meta_data.service_type === 'pickup')]
          this.dropoffCouriers = [...val.filter(f => f.meta_data && f.meta_data.service_type === 'dropoff')]
          if (this.pickupCouriers.length === 0) {
            this.courierService = 'dropoff'
            this.showRadio = false
          } else if (this.dropoffCouriers.length === 0) {
             this.courierService = 'pickup'
             this.showRadio = false
          }
        }
      }
    },
    selectedFulfilment: {
      deep: true,
      handler (val) {
        if (val && val.meta_data) {
          this.courierService = val.meta_data.service_type
        }
      }
    }
  },
  mounted () {
  },
}
</script>

<style scoped>

</style>